import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scrolls the window to the top whenever the route changes.
 *
 * Why: React Router's default behavior is to PRESERVE scroll position across
 * navigations — which is great when going back/forward but disorienting when
 * the user clicks a CTA on mobile and lands on Login/Dashboard halfway down
 * the screen (the exact bug we're fixing here).
 *
 * Behavior:
 *   - Triggers on every `location.pathname` change.
 *   - Honors `location.hash` (anchors like `/#precios`) — does NOT scroll
 *     to top when the user is intentionally jumping to an in-page anchor.
 *   - Uses `window.scrollTo(0, 0)` (instant) instead of smooth so the user
 *     doesn't see a jarring animation between pages.
 *
 * Renders nothing. Mount once near the router root.
 */
export default function ScrollToTop() {
    const { pathname, hash } = useLocation();

    useEffect(() => {
        // If the new URL has an in-page anchor (#precios, #faq), let the
        // browser handle the scroll-to-anchor naturally.
        if (hash) return;
        window.scrollTo(0, 0);
    }, [pathname, hash]);

    return null;
}
